<template>

    <input type="text" @blur="onUpdate" v-model="value" />


</template>

<script>


export default {
    name: "InputText"

}
</script>

<script setup>

import { ref, computed }                 from "vue";
import { getValue, getList } from "../composables/useData";
import { useStore }            from "vuex";

let props = defineProps(["field"]);
let emits = defineEmits(["update","clearErrors"])
let store = useStore();
let value = ref(/*useData.*/getValue(props.field, store.state, "user.profile") );


function onUpdate ()
{
    emits("update", {key: props.field.key, value: value.value})
    emits("clearErrors")
}


function hasField (fields)
{
    let strKey = props.field.key;

    return fields.includes(strKey);
}

function getKey ()
{
    return props.field.key;
}

defineExpose({ hasField, getKey });

</script>
<style scoped>

</style>
